import { render, staticRenderFns } from "./MainFramework.vue?vue&type=template&id=2237313b&scoped=true&"
import script from "./MainFramework.vue?vue&type=script&lang=js&"
export * from "./MainFramework.vue?vue&type=script&lang=js&"
import style0 from "./MainFramework.vue?vue&type=style&index=0&id=2237313b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2237313b",
  null
  
)

export default component.exports